import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { ESourceValue } from '../../../constants';
import { segmentTrackAction, SegmentUserEvent } from '../../../../../../../middlewares/segment';

export const onClick = (
    source: ESourceValue
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        if (source === ESourceValue.FAQ) dispatch(segmentTrackAction(SegmentUserEvent.PERMISSIONS_FAQ_CLICKED));
        if (source === ESourceValue.CONTACT) dispatch(segmentTrackAction(SegmentUserEvent.PERMISSIONS_CONTACT_US_CLICKED))
    };
    return action;
};
